import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import swal from "sweetalert";
import {
    addWriteOffReason,
    deleteWriteOffReason,
    fetchWriteOffFormReasons,
    updateWriteOffReason
} from "../../../action/reasons";

export function ReasonModal({onClose, isEditMode, reason}) {
    const dispatch = useDispatch();
    const [data, setData] = useState({
        name: reason ? reason.name : '',
    })

    useEffect(() => {
        if (isEditMode && reason) {
            setData({
                name: reason.name || '',
            });
        }
        return () => setData({name: ''});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeInput = (field) => (e) => setData({...data, [field]: e.target.value});

    const isValid = () => !!data.name;

    const onSubmit = async (e) => {
        e.preventDefault();

        const reasonData = { name: data.name };

        try {
            let success;
            if (isEditMode) {
                success = await dispatch(updateWriteOffReason(reason.id, reasonData));
            } else {
                success = await dispatch(addWriteOffReason(reasonData));
            }

            if (success) {
                dispatch(fetchWriteOffFormReasons());
            }
        } catch (error) {
            console.log('Error', error);
        } finally {
            onClose();
        }
    }

    const onDelete = () => {
        swal({
            title: `Удаление причины`,
            text: `Вы действительно хотите удалить причину "${reason.name}"?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteWriteOffReason(reason.id)).then(() => {
                    dispatch(fetchWriteOffFormReasons());
                    swal("Поставщик успешно удалён!", {
                        icon: "success",
                    });
                    onClose();
                });
            }
        });
    };

    return (
        <>
            <div className="modal-backdrop fade show" style={{zIndex: 1040}}></div>
            <form onSubmit={onSubmit}>
                <div className="modal fade show" style={{display: 'block', zIndex: 1050}}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {isEditMode ? 'Редактирование причины' : 'Добавить причину'}
                                </h5>
                                <button onClick={onClose} type="button" className="close">
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label className="form-control-label">Название *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={data.name}
                                        onChange={onChangeInput('name')}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                                {isEditMode && (
                                    <button
                                        type="button"
                                        onClick={onDelete}
                                        className="btn btn-danger">
                                        Удалить
                                    </button>
                                )}
                                <button
                                    type="submit"
                                    disabled={!isValid()}
                                    className="btn btn-primary">
                                    {isEditMode ? 'Сохранить' : 'Добавить'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}